// Copyright (c) 2026 Solartek LLC. All rights reserved.

import { Suspense } from 'react';
import type { RouteObject } from 'react-router';
import { RequirePermission } from '@/components/layout/protected-route';
import { MeetingDetailPage, MeetingsPage, PageFallback } from './pages/lazy';
import './i18n';

/** Any meeting key opens the meetings pages (the API and RLS decide which meetings each one reveals). */
const KEYS = ['meeting.view', 'meeting.organize', 'meeting.manage'] as const;
const guarded = (node: React.ReactNode) => <RequirePermission permissions={[...KEYS]} any selfServiceTo="/my/meetings"><Suspense fallback={<PageFallback />}>{node}</Suspense></RequirePermission>;

/** Routes of meetings (workforce controls §7): /meetings?tab=schedule|rooms|analytics, /meetings/:id. The portal's /my/meetings is a portal route. */
export const meetingsRoutes: RouteObject[] = [
  { path: 'meetings', element: guarded(<MeetingsPage />) },
  { path: 'meetings/:id', element: guarded(<MeetingDetailPage />) },
];
